import { render, staticRenderFns } from "./teamscoresOnly.vue?vue&type=template&id=f51cf660&scoped=true"
import script from "./teamscoresOnly.vue?vue&type=script&lang=js"
export * from "./teamscoresOnly.vue?vue&type=script&lang=js"
import style0 from "./teamscoresOnly.vue?vue&type=style&index=0&id=f51cf660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51cf660",
  null
  
)

export default component.exports